import React from 'react';
import {
  AdminPanelSettings as AdminPanelSettingsIcon,
  Bloodtype as BloodtypeIcon,
  DynamicFeed as DynamicFeedIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { BLOOD_TEST_PATH, BOARD_MANUAL_PATH, PATIENTS_PATH } from './routes';

/** サイドナビと同一のメニュー項目（path が null は未実装メニュー） */
export type MainNavItem = {
  key: string;
  label: string;
  path: string | null;
  icon: React.ReactNode;
};

export function getMainNavItems(isAdmin: boolean): MainNavItem[] {
  return [
    {
      key: 'patients',
      label: '患者一覧',
      path: PATIENTS_PATH,
      icon: <PeopleIcon fontSize="small" />,
    },
    {
      key: 'blood-test',
      label: '採血結果解析',
      path: BLOOD_TEST_PATH,
      icon: <BloodtypeIcon fontSize="small" />,
    },
    {
      key: 'board-manual',
      label: '掲示板・マニュアル',
      path: BOARD_MANUAL_PATH,
      icon: <DynamicFeedIcon fontSize="small" />,
    },
    {
      key: 'settings',
      label: '設定',
      path: '/settings',
      icon: <SettingsIcon fontSize="small" />,
    },
    ...(isAdmin
      ? [
          {
            key: 'staff',
            label: '職員管理',
            path: '/staff',
            icon: <AdminPanelSettingsIcon fontSize="small" />,
          },
        ]
      : []),
  ];
}
